import { MusicControls } from './MusicControls';

const img = (name) => `${process.env.PUBLIC_URL}/img/${name}`;

export function ScreenHeader() {
  return (
    <header className="screen-header">
      <button type="button" className="icon-btn" aria-label="Закрыть" data-cuelume-press data-cuelume-release="droplet">
        <img src={img('icon-close.svg')} alt="" draggable="false" />
      </button>
      <img className="header-logo" src={img('logo-head.jpg')} alt="Tabys Games" draggable="false" />
      <MusicControls />
    </header>
  );
}
